import { getAnalyticsRequestMetadata } from "../Analytics";
import { resolveActiveFunctionUrl } from "../../configs/runtimeEnvironment";
import { getFriendlyRefineErrorMessage } from "./refineError";

export async function refineEmpathyCard({
  rawThought,
  translationLanguage = "",
  partnerId = "",
  wallId = "",
  sourceShareId = "",
} = {}, { user, expectedUid = "" } = {}) {
  if (!user || (expectedUid && user.uid !== expectedUid)) {
    const error = new Error(
      "We could not verify your account session. Please try again in a moment."
    );
    error.code = "auth/user-state-not-settled";
    throw error;
  }

  if (typeof user.getIdToken !== "function") {
    const error = new Error(
      "We could not verify your account session. Please try again in a moment."
    );
    error.code = "auth/missing-id-token-provider";
    throw error;
  }

  const url = resolveActiveFunctionUrl("createLettuceTalkCards", {
    devUrl: process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_DEV,
    prodUrl: process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_PROD,
  });

  const idToken = await user.getIdToken();

  if (!url) {
    throw new Error("Missing LettuceTalk cards function URL");
  }

  const requestBody = {
    rawThought,
    translationLanguage,
  };

  // Individual users refine without partner metadata; partner wall flows attach
  // known IDs from refineContexts.js.
  if (partnerId) requestBody.partnerId = partnerId;
  if (wallId) requestBody.wallId = wallId;
  if (sourceShareId) requestBody.sourceShareId = sourceShareId;
  requestBody.outputContext = partnerId ? "mixed" : "private_share";
  Object.assign(requestBody, getAnalyticsRequestMetadata());

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(requestBody),
    mode: "cors",
  });

  const data = await response.json();

  if (!response.ok) {
    const errorCode = data.code || data.error;
    const error = new Error(
      getFriendlyRefineErrorMessage({
        code: errorCode,
        reason: data.reason,
        status: response.status,
      })
    );

    error.status = response.status;
    error.code = errorCode;
    error.reason = data.reason;

    throw error;
  }

  return data;
}
